var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDescending = function SvgDescending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9 11.4477 9.44772 11 10 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H10C9.44772 13 9 12.5523 9 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C4.55228 2 5 2.44772 5 3V13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.29274 9.29305C0.683179 8.90244 1.31634 8.9023 1.70695 9.29274L4.70695 12.2914C5.09756 12.6819 5.0977 13.315 4.70726 13.7056C4.31682 14.0963 3.68366 14.0964 3.29305 13.706L0.293047 10.7073C-0.0975622 10.3168 -0.0976999 9.68366 0.29274 9.29305Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70726 9.29305C8.0977 9.68366 8.09756 10.3168 7.70695 10.7073L4.70695 13.706C4.31634 14.0964 3.68318 14.0963 3.29274 13.7056C2.9023 13.315 2.90244 12.6819 3.29305 12.2914L6.29305 9.29274C6.68366 8.9023 7.31682 8.90244 7.70726 9.29305Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8C9 7.44772 9.44772 7 10 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H10C9.44772 9 9 8.55228 9 8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C9 3.44772 9.44772 3 10 3H11C11.5523 3 12 3.44772 12 4C12 4.55228 11.5523 5 11 5H10C9.44772 5 9 4.55228 9 4Z"
  })));
};
export default SvgDescending;